// src/hooks/useChatHistory.ts
import { useCallback } from "react";
import type { Message, ChatHistoryResponse } from "../types/chat";

type Args = {
  selectedProjectId: number | null | undefined;
  setMessages: React.Dispatch<React.SetStateAction<Message[]>>;
  defaultMsg?: Message;
  setStartD: React.Dispatch<React.SetStateAction<Date>>;
  setEndD: React.Dispatch<React.SetStateAction<Date>>;
  setRange: (r: any[]) => void;
  // React.Dispatch<React.SetStateAction<any[]>>;
};

const parseApiDate = (s: string) => {
  const [y, m, d] = s.split("-").map(Number);
  return new Date(y, m - 1, d);
};

export const useChatHistory = ({
  selectedProjectId,
  setMessages,
  defaultMsg,
  setStartD,
  setEndD,
  setRange,
}: Args) => {
  const fetchChatHistory = useCallback(async (id: string) => {
    if (!selectedProjectId) return;

    const base = process.env.REACT_APP_BACKEND_URL;
    const url = `${base}/get-chat-his?project_id=${selectedProjectId}&chat_id=${encodeURIComponent(id)}`;

    const res = await fetch(url, {
      credentials: "include",
      headers: { "Content-Type": "application/json" },
    });
    if (!res.ok) return;

    const json = (await res.json()) as ChatHistoryResponse;
    const history = (json?.messages ?? []).map((m) => ({
      sender: m.sender,
      text: m.text,
      aiSuggestionMode: m.ai_suggestion_mode ?? false,
    })) as Message[];

    if (defaultMsg) {
      setMessages([defaultMsg, ...history]);
    } else {
      setMessages(history);
    }
    if (json.start_date && json.end_date) {
      const s = parseApiDate(json.start_date);
      const e = parseApiDate(json.end_date);
      setStartD(s);
      setEndD(e);
      setRange([{ startDate: s, endDate: e, key: "selection", color: "#F2065D" }]);
    }
  }, [selectedProjectId, setMessages, defaultMsg, setStartD, setEndD, setRange]);
  return { fetchChatHistory };
};
